<template>
    <section class="user-stories-section py-5 bg-light text-center ">
      <div class="container">
        <h2 class="mb-4">🎥 Share Your Ride – Get 15% Off Next Time!</h2>
        <p class="lead mb-4">
          Enjoyed a ride with Poorent in Rome? Record a short video or take a photo and send it to us on WhatsApp. We'll feature it on our website – and you’ll get a 15% discount on your next booking!
        </p>
        <a
          class="btn btn-success btn-lg"
          href="https://wa.me/393806852464"
          target="_blank"
        >
          📲 Send via WhatsApp
        </a>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'UserStoriesSection',
  };
  </script>
  
  <style scoped>
  .user-stories-section {
    
 
    color: #111;
    
    text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.6);
  }
  </style>
  